import { render, staticRenderFns } from "./MessageWrapper.vue?vue&type=template&id=2c0c94ae&"
import script from "./MessageWrapper.vue?vue&type=script&lang=js&"
export * from "./MessageWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports